export default "/images/vendor/flag-icon-css/flags/1x1/sh.svg?17279211d42d3c798e857c12efbd469e";